import React, { useState } from "react";
import { Button, Col, Form, Row } from "reactstrap";
import { useContext } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import AppContext from "../../context/Context";
import APICall from "../../services/apiCall";
import SikkaInput from "../common/SikkaInput";
import Loader from "../common/Loader";

const AppStatusUpdateModal = ({
  applicationData,
  setOpenAppStatusUpdateModal,
  // setFetchAfterUpdate,
  setFetchApplicationDetails,
  selectedAppStatus,
  partnerDetails,
  setFetchAfterUpdate,partnerDevId
}) => {
  const [loading, setLoading] = useState(false);

  const { loginUserDetails } = useContext(AppContext);

  const { register, handleSubmit, errors } = useForm();

  const handleUpdateSLAPlan = (values) => {
    setFetchAfterUpdate(false);
    setLoading(true);
    let body = {
      status: selectedAppStatus, // value shold be verified/expired/test
      app_id: applicationData.app_id,
      application_name: applicationData.app_name,
      partner_name: partnerDetails.partner_name,
      add_updated_by: values.updatedBy, //loggedin user's username
      is_add_updated_by_admin: loginUserDetails.is_partner === "0" ? "true" : "false",
      before_updated_value: {
        status: applicationData.app_status,
      },
      dev_id:partnerDevId,
      user_dev_id:loginUserDetails.dev_id
    };

    APICall.servertrip("PUT", "application_status", loginUserDetails, undefined, body).then(
      (res) => {
        toast.success("Application status successfully updated");
        setOpenAppStatusUpdateModal(false);
        setFetchApplicationDetails(true);
        setLoading(false);
        setFetchAfterUpdate(true);
      },
      (error) => {
        const resMessage =
        (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        toast.error(resMessage);
        setLoading(false);
        setOpenAppStatusUpdateModal(false);
        setFetchAfterUpdate(false);
      }
    );
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Form onSubmit={handleSubmit(handleUpdateSLAPlan)}>
          <Row>
            <Col>
              <SikkaInput
                label="Updated By"
                value={loginUserDetails.user_name}
                name="updatedBy"
                id="updatedBy"
                disabled
                innerRef={register({
                  required: "Zip Code is required",
                })}
                errors={errors}
              />
              <SikkaInput
                label="Comment"
                name="comment"
                type="textarea"
                id="comment"
                innerRef={register({
                  required: "Comment is required",
                  pattern: {
                    value: /^[^\s]+(\s+[^\s]+)*$/,
                    message: "Invalid comment",
                  },
                })}
                errors={errors}
              />
            </Col>
          </Row>
          <Row
            className="modal-footer px-md-3 bg-light"
            style={{
              marginLeft: "-16px",
              marginRight: "-16px",
              marginBottom: "-16px",
            }}
          >
            <Button color="outline-primary" size="sm" className="ml-auto" type="submit">
              Submit
            </Button>
            <Button
              size="sm"
              color="outline-secondary"
              onClick={() => {
                setOpenAppStatusUpdateModal(false);
              }}
            >
              Cancel
            </Button>
          </Row>
        </Form>
      )}
    </>
  );
};

export default AppStatusUpdateModal;
